import { render, staticRenderFns } from "./planned-issue-definitions.vue?vue&type=template&id=70f875c8&"
import script from "./planned-issue-definitions.vue?vue&type=script&lang=js&"
export * from "./planned-issue-definitions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports